import { CKContainerProps, CKLayoutGrid } from 'clearkit';

export const PageWrapper = ({ children, ...rest }: CKContainerProps) => (
  <CKLayoutGrid
    {...rest}
    className="@container/list"
    gap="0"
    gridTemplateRows="1fr auto"
  >
    {children}
  </CKLayoutGrid>
);
